module.exports = __webpack_public_path__ + "img/zoom-out_btn.f50fe163.svg";